(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-steps-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const list = document.querySelector('.media-steps-grid__list');
    const videos = Array.from(document.querySelectorAll('.media-steps-grid__video[data-src]'));
    if (!list || !videos.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let started = false;

    const loadVideo = (video) => {
      const src = video.getAttribute('data-src');
      if (!src) return;
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.removeAttribute('data-src');
      video.load();
    };

    const playAt = (index) => {
      videos.forEach((video, i) => {
        if (i === index) return;
        video.pause();
        video.currentTime = 0;
      });
      const current = videos[index];
      current.currentTime = 0;
      current.play().catch(() => {});
    };

    const startSequence = () => {
      if (started) return;
      started = true;
      videos.forEach(loadVideo);

      videos.forEach((video, i) => {
        video.addEventListener('ended', () => {
          playAt((i + 1) % videos.length);
        });
      });

      if (!reduceMotion) {
        playAt(0);
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              startSequence();
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      observer.observe(list);
    } else {
      startSequence();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-join-us-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const row = document.querySelector('[data-pjv-row]');
    if (!row) return;
    const prev = document.querySelector('[data-pjv-prev]');
    const next = document.querySelector('[data-pjv-next]');
    const scrollByAmount = () => row.clientWidth * 0.8;
    prev?.addEventListener('click', () => row.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => row.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }));

    // <video> elements are already paused on every modal close by Dawn's own
    // ModalDialog.hide() (window.pauseAllMedia()). YouTube iframes aren't
    // covered by that (it only targets .js-youtube-class players), so reset
    // their src here to stop playback — listening on document.body for
    // 'modalClosed' (dispatched by ModalDialog.hide()) rather than a
    // 'beforehide' event on the modal itself, which Dawn never dispatches.
    // Also: querying via `row` doesn't work here — <modal-dialog> relocates
    // itself to a direct child of <body> as soon as it connects, so by the
    // time this script runs the modals are no longer inside `row` at all.
    document.body.addEventListener('modalClosed', () => {
      document.querySelectorAll('.pdp-join-us__modal-media iframe').forEach((iframe) => {
        iframe.setAttribute('src', iframe.getAttribute('src'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
